export function getDefaultPhaseRange(self) {
  return {
    min: self._object.phase_pos * self._object.displaymax,
    max:
      self._object.phase_pos * self._object.displaymax +
      self._object.displaymax -
      1,
  };
}

export function handlePagedVisibility(elems, range) {
  _.each(elems, function (row, idx) {
    if (idx < range.min || idx > range.max) {
      $(row).hide();
    } else {
      $(row).show();
    }
  });
}

export function isRequiredSatisfied(self, context = false) {
  if (!context) context = self;
  var required = context.required === 'HARD' ? true : false;
  var soft_required = context.soft_required;
  if (required || (soft_required && !self.displaymax_soft_prompts)) {
    if (self.selected_rows_count() < self.visible_rows_count()) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}

export function resolvePagedElems(self, elems) {
  var resolved = elems || self.$el.find('.dynamic-row');
  return resolved.length === 0 ? null : resolved;
}
